import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authApi } from '@services/auth.service'
import { AuthLayout } from '@components/layout/AuthLayout'
import { Button } from '@components/ui/button'
import { Input } from '@components/ui/input'
import { Label } from '@components/ui/label'
import { cn } from '@lib/utils'
import { ArrowLeft, CheckCircle2, Loader2, Mail } from 'lucide-react'

export function ForgotCredentialsPage() {
  const [identifier, setIdentifier] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [confirmation, setConfirmation] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!identifier.trim()) return

    setIsLoading(true)
    try {
      const response = await authApi.requestCredentialReset(identifier.trim())
      setConfirmation(
        response?.message ||
          'Si la cuenta existe, tu administrador de TI ha sido notificado para restablecer tus credenciales.'
      )
    } catch {
      // Never reveal whether the account exists — show the same neutral message.
      setConfirmation(
        'Si la cuenta existe, tu administrador de TI ha sido notificado para restablecer tus credenciales.'
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthLayout>
      <p className="auth-eyebrow">Portal de acceso clínico</p>
      <h2 className="auth-title">Recuperar credenciales</h2>
      <p className="auth-subtitle">
        Ingresa tu correo o ID de especialista y notificaremos a tu administrador de TI para
        restablecer tu acceso.
      </p>

      {confirmation ? (
        <div className="mt-6 space-y-6">
          <div className="auth-success" role="status" aria-live="polite">
            <CheckCircle2 size={18} strokeWidth={2} />
            <span>{confirmation}</span>
          </div>
          <p className="auth-hint" role="note">
            Tu administrador procesará la solicitud y se pondrá en contacto contigo. Si es urgente,
            comunícate directamente con el área de TI.
          </p>
          <Link to="/login" className="auth-back">
            <ArrowLeft size={16} strokeWidth={2} />
            Volver al inicio de sesión
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="identifier">ID de especialista / Correo</Label>
            <div className="auth-input-wrap">
              <Mail className="auth-input-icon" size={18} strokeWidth={1.75} />
              <Input
                type="text"
                id="identifier"
                name="identifier"
                placeholder="nombre@clinica.com"
                required
                autoComplete="username"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className={cn('h-12 pl-11')}
              />
            </div>
          </div>

          <Button type="submit" className="auth-submit" disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 size={18} strokeWidth={2} className="animate-spin" />
                Enviando solicitud…
              </>
            ) : (
              'Enviar solicitud'
            )}
          </Button>

          <div className="flex justify-center">
            <Link to="/login" className="auth-back">
              <ArrowLeft size={16} strokeWidth={2} />
              Volver al inicio de sesión
            </Link>
          </div>
        </form>
      )}
    </AuthLayout>
  )
}
